import { deleteKeysWithSubstring, isModule } from "utils"

import { dateTimeFunction } from "utils/date"

const getQueryTransformObject = (params, sortOrder, type) => {
  if (type === "client-listings") {
    const checkDate = key => {
      if (!!params[key]) {
        const dateR = params[key].split(",")
        params[key] = encodeURIComponent(
          `{"from":"${dateTimeFunction({ date: dateR[0], timeZone: true, apiRequest: true })}","to":"${dateTimeFunction(
            {
              date: dateR[1],
              timeZone: true,
              apiRequest: true,
            }
          )}"}`
        )
      }
    }
    const checkUsers = key => {
      if (!!params[key]) {
        let childIdentifierKey = key + "_withoutChildren"
        params[key] = `{"userIds":[${params.allocatedTo}],"includeAllChildren":${!params?.[childIdentifierKey]}}`
      }
    }
    // Transform range filters from "min,max" to { from, to } object
    const checkRange = key => {
      if (!!params[key]) {
        const rangeValues = params[key].split(",")
        const from = parseFloat(rangeValues[0]) || 0
        const to = parseFloat(rangeValues[1]) || 0
        params[key] = encodeURIComponent(`{"from":${from},"to":${to}}`)
      }
    }

    checkDate("createdAt")
    checkDate("stageUpdatedAt")
    checkUsers("allocatedTo")

    // Transform range filters for client profiling
    checkRange("netWorth")
    checkRange("annualRevenueAUM")
    checkRange("targetAllocation")
    checkRange("targetAnnualIncomePercent")
    checkRange("targetCapitalReturnPercent")

    params = deleteKeysWithSubstring(params, "_withoutChildren")

    return {
      pageLimit: 10,
      page: 0,
      ...(sortOrder && { orderBy: sortOrder }),
      ...params,
    }
  } else {
    const isSharedLeadsPage = isModule("shared-leads")

    const checkPurpose = () => {
      if (params.purpose) {
        const [purposeId, leadSide] = params.purpose.split("-")
        if (purposeId) params["purposeId"] = purposeId
        if (leadSide) params["leadSide"] = leadSide
        delete params["purpose"]
      }
    }
    const checkUsers = key => {
      if (!!params[key]) {
        let childIdentifierKey = key + "_withoutChildren"
        params[key] = encodeURIComponent(
          `{"teamIds":[],"userIds":[${decodeURIComponent(params[key])}],"includeAllChildren":${!params?.[
            childIdentifierKey
          ]}}`
        )
      }
    }
    const checkDate = key => {
      if (!!params[key]) {
        const dateR = params[key].split(",")
        params[key] = encodeURIComponent(
          `{"from":"${dateTimeFunction({ date: dateR[0], timeZone: true, apiRequest: true })}","to":"${dateTimeFunction(
            {
              date: dateR[1],
              timeZone: true,
              apiRequest: true,
            }
          )}"}`
        )
      }
    }

    // Transform range filters from "min,max" to { from, to } object
    const checkRange = key => {
      if (!!params[key]) {
        const rangeValues = params[key].split(",")
        const from = parseFloat(rangeValues[0]) || 0
        const to = parseFloat(rangeValues[1]) || 0
        params[key] = encodeURIComponent(`{"from":${from},"to":${to}}`)
      }
    }

    const checkBooleanValue = key => {
      if(!!params[key]){
      params[key] = params[key] === "true"
      }
    }

    checkUsers("taskAllocatedTo")
    checkUsers("sharedWith")
    checkUsers("sharedBy")
    checkUsers("allocatedTo")
    checkUsers("watchlistAddedBy")
    checkUsers("reviewedBy")
    checkDate("createdAt")
    checkDate("taskAllocatedDate")
    checkDate("timeAllocation")
    checkDate("lastTaskAdded")
    checkDate("dateShared")
    checkDate("reviewDate")
    checkPurpose()

    // Transform range filters for client profiling
    checkRange("netWorth")
    checkRange("annualRevenueAUM")
    checkRange("targetAllocation")
    checkRange("targetAnnualIncomePercent")
    checkRange("targetCapitalReturnPercent")
    checkRange("budget")

    checkBooleanValue("politicalExposure")
    checkBooleanValue("realEstateIndustryExposure")
    checkBooleanValue("hasExistingProperty")

    params = deleteKeysWithSubstring(params, "_withoutChildren")
    if (isSharedLeadsPage) {
      params["teamTypeKey"] = "telesales"
  } 
    return params
  }
}

export default getQueryTransformObject
